function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import renderIf from '@signal/utils/renderIf';
import { component } from '@signal/prop-types';
import { Wrapper, TimelineWrapper, Title, Description } from './styles';

var PathToSaleSkeleton = function PathToSaleSkeleton(_ref) {
  var TimelineView = _ref.timelineViewComponent,
      title = _ref.title,
      titleProps = _ref.titleProps,
      description = _ref.description,
      descriptionProps = _ref.descriptionProps,
      rest = _objectWithoutProperties(_ref, ["timelineViewComponent", "title", "titleProps", "description", "descriptionProps"]);

  return /*#__PURE__*/React.createElement(Wrapper, null, renderIf(isString(title), function () {
    return /*#__PURE__*/React.createElement(Title, titleProps, title);
  }, title), renderIf(isString(description), function () {
    return /*#__PURE__*/React.createElement(Description, Object.assign({
      variant: "subtitle2"
    }, descriptionProps), description);
  }, description), /*#__PURE__*/React.createElement(TimelineWrapper, null, /*#__PURE__*/React.createElement(TimelineView, rest)));
};

PathToSaleSkeleton.propTypes = {
  timelineViewComponent: component.isRequired,
  title: PropTypes.node,
  titleProps: PropTypes.object,
  description: PropTypes.node,
  descriptionProps: PropTypes.object
};
export default PathToSaleSkeleton;